import React, { useState } from 'react';
import { useTranslation } from '../hooks/useTranslation';
import { Section } from './Section';
import { SectionItemMore } from './SectionItemMore';
export function ListSection({ Component, items, title, count, maxCollapsed = 5, }) {
    var _a;
    const [collapsed, setCollapsed] = useState(true);
    const type = title || ((_a = items[0]) === null || _a === void 0 ? void 0 : _a.type) || 'unknown';
    const visibleItems = collapsed ? items.slice(0, maxCollapsed) : items;
    const moreElement = visibleItems.length < items.length ? (React.createElement(SectionItemMore, { onClick: () => setCollapsed(false) }, "Show all")) : null;
    const counter = count > 500 ? '500+' : count;
    return (React.createElement(Section, { title: type, counter: counter },
        visibleItems.map((item, index) => (React.createElement(Component, { key: index, type: item.type, value: item.value, highlights: item.highlights, position: index + 1 }))),
        moreElement));
}
export function createListSection(Component, parentProps = {}) {
    return (props) => (React.createElement(ListSection, { Component: Component, items: props.items, title: useTranslation(props.title || parentProps.title), count: props.count, maxCollapsed: props.maxCollapsed || parentProps.maxCollapsed }));
}
//# sourceMappingURL=ListSection.js.map